module.exports = __webpack_public_path__ + "static/media/icofont.9999a483.svg";